module.exports = __webpack_public_path__ + "3f4f9484a4072d8392b09e365a8ebdad.pdf";